<template>
    <div class="board-container">
        <div class="tab-wrap tab-wrap--lg" data-aos="fade-up" data-aos-delay="100">
            <u-tabs-solid>
                <v-tab @click="input(null)">전체</v-tab>
                <v-tab v-for="(category, index) in categories" :key="index" @change="input(category)"> {{ category }} </v-tab>
            </u-tabs-solid>
        </div>

        <v-row class="row--xs search--primary" data-aos="fade-up" data-aos-delay="200">
            <v-spacer />
            <v-col cols="12" md="auto">
                <v-select v-model="filter.searchKey" :items="searchKeys" class="v-input--small w-100 w-md-120px" outlined hide-details @change="search(true)" />
            </v-col>
            <v-col md="auto">
                <v-text-field v-model="filter.searchValue" class="v-input--small w-100 w-md-240px" outlined hide-details placeholder="검색어를 입력하세요." :disabled="!filter.searchKey" @input="search(true)" />
            </v-col>
            <v-col cols="auto">
                <v-btn dark class="h-100 w-100 min-w-md-60px" color="grey" @click="search()">검색</v-btn>
            </v-col>
        </v-row>

        <table class="board-list mt-12px mt-md-24px" data-aos="fade-up" data-aos-delay="200">
            <thead class="d-none d-lg-table-header">
                <tr>
                    <th style="width:12%;">구분</th>
                    <th style="width:58%;">제목</th>
                    <th style="width:18%;">작성일</th>
                    <th style="width:12%;">조회</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(notification, index) in fixed" :key="index" @click="$router.push(`${$route.path}/${notification._id}`)" class="board-list__notice">
                    <td align="center" class="board-list__txt board-list__txt--first">
                        <v-layout align-center justify-center>
                            <v-icon color="primary" class="font-size-16 font-size-md-20 mr-4px">mdi-alert-circle</v-icon>
                            <span class="font-weight-bold secondary--text">{{ notification.category }}</span>
                        </v-layout>                        
                    </td>
                    <td align="center" class="board-list__tit">
                        <div class="text-truncate">
                            <span>{{ notification.subject }}</span>
                        </div>
                    </td>
                    <td align="center" class="board-list__txt">
                        {{ notification.createdAt.toDate() }}
                    </td>
                    <td align="center" class="board-list__txt">
                        {{ notification.viewCount }}
                    </td>
                </tr>

                <tr v-for="(notification, index) in notifications" :key="index" @click="$router.push(`${$route.path}/${notification._id}`)">
                    <td align="center" class="board-list__txt board-list__txt--first">
                        <span class="font-weight-bold secondary--text">{{ notification.category }}</span>
                    </td>
                    <td align="center" class="board-list__tit">
                        <div class="text-truncate">
                            <span>{{ notification.subject }}</span>
                        </div>
                    </td>
                    <td align="center" class="board-list__txt">
                        {{ notification.createdAt.toDate() }}
                    </td>
                    <td align="center" class="board-list__txt">
                        {{ notification.viewCount }}
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="v-pagination-wrap">
            <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)" />
        </div>
        <!-- <pagination-component v-model="page" :count="pageCount" @input="search"></pagination-component> -->

    </div>
</template>

<script>
import api from "@/api";
import UTabsSolid from "@/components/dumb/u-tabs-solid.vue";
import PaginationComponent from "@/components/client/control/pagination-component.vue";
import { mdiAlertCircleOutline } from "@mdi/js";
export default {
    components: {
        UTabsSolid,
        PaginationComponent,
    },
    props: {
        value: { type: String, default: null },
    },
    data() {
        return {
            mdiAlertCircleOutline,

            filter: {
                isNotice: false,
                category: this.$route.query.category || null,
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 20,

            fixed: [],
            notifications: [],
            categories: ["공지", "교육", "자료", "지원", "행사", "뉴스"],
            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "제목 + 내용", value: "subjectcontent" },
                { text: "제목", value: "subject" },
            ],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            await this.search();
        },
        async search(routable = false) {
            if (routable) {
                this.$router.push({
                    query: { ...this.filter, page: this.page },
                });
                return;
            }

            var { notifications: fixed } = await api.v1.center.notifications.gets({
                headers: {
                    limit: 0,
                },
                params: { isNotice: true },
            });

            this.fixed = fixed;

            var { summary, notifications } = await api.v1.center.notifications.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter,
            });

            this.notifications = notifications;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        input(category) {
            this.$route.query.category = category;
            this.$route.query.searchKey = null;
            this.$route.query.searchValue = null;
            this.filter.searchKey = null;
            this.filter.searchValue = null;
            this.filter.category = category;
            this.search();
        },
    },
};
</script>
